import { useAtom, useAtomValue } from 'jotai';
import { stopPointsAtom, stopPointsLatLngSelector } from './states';
import { useEnvironmentAPI, usePlacesAPI } from '@api/fms';
import { useCallback, useState } from 'react';
import { environmentAtom } from '../environment/states';
import { useAtomCallback } from 'jotai/utils';
import { useMount } from 'react-use';

export const useStopPoints = () => {
  const [stopPoints, setStopPoints] = useAtom(stopPointsAtom);
  const stopPointsLatLng = useAtomValue(stopPointsLatLngSelector);

  return {
    stopPoints,
    setStopPoints,
    stopPointsLatLng,
  };
};

export const useLoadStopPoints = (loadOnMount = true) => {
  const { getEnvironment } = useEnvironmentAPI();
  const { getPlaces } = usePlacesAPI();
  const [isLoaded, setIsLoaded] = useState(false);

  const loadStopPoints = useAtomCallback(
    useCallback(
      async (get, set) => {
        const environment = get(environmentAtom);
        if (!environment) {
          setIsLoaded(true);
          return;
        }
        const environmentRes = await getEnvironment(environment.environment_id);
        if (!environmentRes) {
          setIsLoaded(true);
          return;
        }
        set(environmentAtom, environmentRes);

        if (
          environment.area_map_version_id !== environmentRes.area_map_version_id
        ) {
          const stopPointsRes = await getPlaces();
          set(stopPointsAtom, stopPointsRes);
        }
        setIsLoaded(true);
      },
      [getEnvironment, getPlaces],
    ),
  );

  useMount(() => {
    if (!loadOnMount) return;
    loadStopPoints();
  });

  return {
    isLoaded,
    loadStopPoints,
  };
};
